import { clientConfig } from '../../config';

const BASE_WEBSITE_URL = clientConfig.MAIN_WEBSITE_URL;

export const FAQ_LINKS: Record<string, string> = {
    DE: 'https://help.doktorabc.com/de',
    'CH-de': `${BASE_WEBSITE_URL}/ch-de/faq.html`,
    'CH-fr': `${BASE_WEBSITE_URL}/ch-fr/faq.html`,
    FR: `${BASE_WEBSITE_URL}/fr/faq.html`,
    GB: `${BASE_WEBSITE_URL}/uk/faq.html`,
};

export function getFaqUrl(country: string, language?: string): string {
    const c = country?.toUpperCase();
    if (c === 'CH-FR') return FAQ_LINKS['CH-fr'];
    if (c === 'CH-DE' || c === 'CH') {
        const lang = language?.toLowerCase() || 'de';
        return FAQ_LINKS[`CH-${lang}`] || FAQ_LINKS['CH-de'];
    }
    return FAQ_LINKS[c] || FAQ_LINKS['DE'];
}

export function getUrlPrefix(country: string, language?: string): string {
    const c = (country || '').toUpperCase();
    if (c === 'CH-FR') return 'ch-fr';
    if (c === 'CH-DE') return 'ch-de';
    const l = (language || '').toLowerCase();
    if (c === 'CH' && l && l !== 'de') {
        return `ch-${l}`;
    }
    return c.toLowerCase();
}

export function isSupportHoursActive(country?: string): boolean {
    const now = new Date();
    const jan = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();
    const isDST = now.getTimezoneOffset() < Math.max(jan, jul);

    const c = (country || '').toUpperCase();
    const utcOffset = (c === 'GB' || c === 'UK') ? (isDST ? 1 : 0) : (isDST ? 2 : 1);

    const localHours = (now.getUTCHours() + utcOffset) % 24;
    return localHours >= 6 && localHours < 21;
}

export function isWhatsAppAvailable(): boolean {
    return isSupportHoursActive('DE');
}

export function getIsReturningCustomer(): boolean {
    try {
        return !!(window as any).eventsTracking?.getData?.('last_paid_order');
    } catch { return false; }
}

export function openWhatsAppChat(number: string, message: string): void {
    const msg = encodeURIComponent(message);
    window.open(`https://wa.me/${number}?text=${msg}`, '_blank');
}

export function openHubSpotChat(): void {
    try {
        const api = (window as any).HubSpotConversations;
        if (!api?.widget) return;

        const container = document.getElementById('hubspot-messages-iframe-container');

        const trustBadge = document.querySelector('[id^="trustbadge-container-"]') as HTMLElement;

        const showChat = () => {
            if (container) {
                container.style.setProperty('opacity', '1', 'important');
                container.style.setProperty('pointer-events', 'auto', 'important');
            }
            if (trustBadge) trustBadge.style.setProperty('display', 'none', 'important');
            api.widget.open();
        };

        api.on('widgetClosed', () => {
            if (container) {
                container.style.setProperty('opacity', '0', 'important');
                container.style.setProperty('pointer-events', 'none', 'important');
            }
            if (trustBadge) trustBadge.style.removeProperty('display');
        });

        const status = api.widget.status();
        if (status.loaded) {
            showChat();
        } else {
            api.widget.load();
            api.on('widgetLoaded', () => showChat());
        }
    } catch { /* noop */ }
}
